
export const CaseStates = Object.freeze({
    "CLOSED":4,
    "IN_PROGRESS":2,
    "FACTORY_PROCESS":3,
    
    "RACE_TRACING":1004,
    "PAU_TRACING":1005,
    "NOT_MANAGED": 1006,
    "MAINTENANCE_TRACING": 1007,
    "FACTORY_PROCESS_RETURN": 1008,
    "CIC_TRACING": 1009,
    "CIC_FACTORY_PROCESS": 10010,
})
